function resolveFormToShow(url) {
  let elementToShow;
  let elementToHide;
  if (url.indexOf('#recover') !== -1) {
    elementToShow = document.querySelector('#customer_recover');
    elementToHide = document.querySelector('#customer_login');
  } else {
    elementToShow = document.querySelector('#customer_login');
    elementToHide = document.querySelector('#customer_recover');
  }

  elementToShow.classList.remove('d-none');
  elementToHide.classList.add('d-none');
}

window.addEventListener('hashchange', function(event) {
  resolveFormToShow(event.newURL);
});

window.addEventListener('DOMContentLoaded', function() {
  resolveFormToShow(window.location.hash);
});